import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Activity, ActivityService } from "@rubbl-activity";
import { AzureSearchRequest, AzureSearchService } from "@rubbl-azure-search";
import { SearchModel } from "@rubbl-core";
import { InventoryItem } from "@rubbl-inventory";
import { RentalItemState, RentalItemStateSearchModel, RentalItemStateService, RentalRequest, RentalRequestItem } from "@rubbl-order";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-machine-reviews",
  templateUrl: "./machine-reviews.component.html",
  styleUrls: ["./machine-reviews.component.scss"],
  providers: [DatePipe, RentalItemStateService],
})
export class MachineReviewsComponent implements OnInit {
  @Input() machine: InventoryItem;
  activities: Activity[];

  numberOfCancels: number = 0;
  reviews: any[];

  constructor(
    private azureSearchService: AzureSearchService,
    private datePipe: DatePipe,
    private activityService: ActivityService,
    private rentalItemStateService: RentalItemStateService,
  ) {}

  ngOnInit(): void {
    // this.machine.id = `7f161436-698e-4e88-b5de-1a49e1dc752f`;

    const activitySearch = new SearchModel();
    activitySearch["inventoryItemId"] = this.machine.id;
    activitySearch["activityCode"] = "MACHINE-AVAILABILITY";

    const rentalItemSearch = new RentalItemStateSearchModel();
    rentalItemSearch["inventoryItemId"] = this.machine.id;
    forkJoin({
      activities: this.activityService.getAll(activitySearch),
      rentalItemStates: this.rentalItemStateService.getAll(rentalItemSearch),
    }).subscribe(results => {
      const rentalItemStates = results.rentalItemStates.results.filter(d => d.status == "Completed" || d.status == "ReturnFulfillment");
      this.goThroughActivities(results.activities.results, rentalItemStates);
    });
  }

  goThroughActivities(activities: Activity[], rentalItemStates: RentalItemState[]) {
    let reviews = [];
    for (let activity of activities) {
      if (activity.status == "Closed") {
        if (activity.activityResponse == "false") {
          this.numberOfCancels++;

          const notAvailableReason = activity?.metadata?.notAvailableReason ? activity.metadata.notAvailableReason : "Currently in operation.";

          reviews.push({
            date: new Date(activity.completedDateTime),
            header: `<span class='bold fs-15 mr-1'>Rubbl</span> <span class='font-weight-light fs-13 text-grey'>${this.datePipe.transform(
              activity.completedDateTime,
            )}</span>`,
            subHeader: `This machine was not available due to the following reason: ${notAvailableReason}. <div class='font-weight-light fs-12'>This message was automatically posted by Rubbl.</div>`,
          });
        }
      }
    }

    for (let rentalItemState of rentalItemStates) {
      const startDateTime = rentalItemState?.returnFulfillment?.startDateTime;
      reviews.push({
        date: new Date(startDateTime),
        header: `<span class='bold fs-15 mr-1'>Rubbl</span> <span class='font-weight-light fs-13 text-grey'>${this.datePipe.transform(startDateTime)}</span>`,
        subHeader: `This machine completed a ${rentalItemState.onRent.daysInStage} day rental.  <div class='font-weight-light fs-12 '>This message was automatically posted by Rubbl.</div>`,
      });
    }

    const sortByDate = (a, b) => b.date - a.date;
    reviews = reviews.sort(sortByDate);

    this.reviews = reviews;
  }
}
